import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BankAccountTransactionFilter  {
    _originalTypeClassName = "zERP.BO.BankAccountTransactionFilter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BankAccountTransactionFilter.translate = translateService;
}
this.BankAccount = new Domain.BankAccount();
this.From = null;
this.To = null;
this.BankAccountTransactionFilterKey = null;
this._key = this.BankAccountTransactionFilterKey = 0; 
}

static translate: TranslateService;
_key: any;
From:any;
To:any;
BankAccount:any;
private _BankAccountTransactionFilterKey:any;
get BankAccountTransactionFilterKey(): any {
    return this._BankAccountTransactionFilterKey;
  }
set BankAccountTransactionFilterKey(value: any) {
    this._BankAccountTransactionFilterKey = value;
    this._key = value;
  }
static setBankAccount = ($this, value) => {
var oldValue = $this.BankAccount;
$this.BankAccount = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BankAccountTransactionFilterKey == null || $this.BankAccountTransactionFilterKey == 0;
            }


}